// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationAdditionId } from './FermentationAddition';
import { invItemId } from './InvItem';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationAdditionItemId = (z.number());
export const fermentationAdditionItem = z.object({
    id: fermentationAdditionItemId,
    addition_id: fermentationAdditionId,
    inventory_item_id: invItemId,
    created_at: z.date(),
    created_by: operatorId.nullable(),
});
export const fermentationAdditionItemInitializer = z.object({
    id: fermentationAdditionItemId.optional(),
    addition_id: fermentationAdditionId,
    inventory_item_id: invItemId,
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const fermentationAdditionItemMutator = z.object({
    id: fermentationAdditionItemId.optional(),
    addition_id: fermentationAdditionId.optional(),
    inventory_item_id: invItemId.optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationAdditionItem.js.map